<script setup lang="ts">
import { toHead } from 'vue-datocms'
import { queryPage } from '~/graphql/page'
import { useSchemaGraph, buildSchemaWebPage } from '~/composables/schema'
import { schemaIds } from '~/types/schema'

const route = useRoute()
const { resolveSectionComponent } = useResolveComponent()
const { throwError } = useNuxtError()

const { data, error } = await useDatoQuery(queryPage, {
  variables: {
    slug: route.params.slug as string
  }
})

if (!data.value?.page || error.value) {
  console.error(error.value)
  throwError(404)
}

if (data.value?.page?.colorTheme && import.meta.env.SSR) {
  useTheme(data.value?.page?.colorTheme as unknown as AppTheme)
}

onMounted(() => {
  if (data.value?.page?.colorTheme && import.meta.client) {
    useTheme(data.value?.page?.colorTheme as unknown as AppTheme)
  }
})

useHead(() => {
  return toHead(data.value?.page?._seoMetaTags || [])
})

const config = useRuntimeConfig()
const { usePageSchema } = useSchemaGraph()
const ids = schemaIds(config.public.appUrl)
const base = config.public.appUrl.replace(/\/$/, '')

usePageSchema([
  buildSchemaWebPage({
    id: `${base}${route.path}#webpage`,
    url: `${base}${route.path}`,
    name: data.value?.page?.title ?? undefined,
    inLanguage: 'en',
    isPartOf: { '@id': ids.WEBSITE }
  })
])
</script>

<template>
  <div v-if="data?.page">
    <component
      :is="resolveSectionComponent(item.__typename as SectionComponents)"
      v-for="(item, index) in data.page?.modules"
      :key="item.id"
      :data="item"
      :module-index="index"
      class="relative"
    />
  </div>
</template>
